// extracted by mini-css-extract-plugin
export var chip = "_eh-0";
export var filterDropdown = "_eh-5";
export var filterItem = "_eh-6";
export var icon = "_eh-1";
export var removeButton = "_eh-3";
export var removeIcon = "_eh-4";
export var separator = "_eh-2";